import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCompanyContact'
})

export class FilterPipeContactCompany implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) { return []; }
    if (!searchText) { return items; }
    //searchText = searchText.toLowerCase();
    const removeAccents = (str: string) => {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };
    const normalizedSearch = removeAccents(searchText.toLowerCase());
    return items.filter(it => {
      const givenName = removeAccents((it['user']['givenName'] || '').toLowerCase());
      const familyName = removeAccents((it['user']['familyName'] || '').toLowerCase());
      const fullName = givenName + " " + familyName;
      const reversefullName = familyName + " " + givenName;
      return fullName.includes(normalizedSearch) || reversefullName.includes(normalizedSearch);
      //return it['givenName'].toLowerCase().includes(searchText) || it['familyName'].toLowerCase().includes(searchText);
    });
  }
}
